export default __webpack_public_path__ + "static/media/Hittrax.f1f87b10.jpeg";